import { CircularProgress } from '@material-ui/core';
import React from 'react';

import {
  BoardDetailsFragment,
  UpdateBoardInput,
  useCreateBoardMutation,
  useGetPlexDetailsQuery,
} from '../../../../graphql/gen/types';
import { logAnalytics } from '../../shared/logAnalytics';
import { useDialogState } from '../useDialogState';
import { BaseBoardDialog } from './BaseBoardDialog';

export function CreateBoardDialog({ plexId }: { plexId: string }): React.ReactElement | null {
  const [, setDialogState] = useDialogState();
  const { data: plexData } = useGetPlexDetailsQuery({ variables: { plexId } });
  const [createBoardMutation, { loading, error }] = useCreateBoardMutation();

  if (plexData?.loggedIn?.plexById == null) {
    return <CircularProgress size={24} />;
  }

  const defaultBoard: Omit<BoardDetailsFragment, 'id' | 'position'> = {
    name: '',
    description: '',
    plexId,
    plex: plexData.loggedIn.plexById,
  };

  const createBoard = (board: UpdateBoardInput): void => {
    createBoardMutation({
      variables: {
        board: {
          ...board,
          plexId,
        },
      },
      update: (cache, { data }) => {
        if (data?.createBoard != null) {
          cache.evict({
            id: cache.identify({ __typename: 'Plex', id: data.createBoard.plexId }),
            fieldName: 'boards',
          });
        }
      },
    })
      .then(({ data }) => {
        if (data?.createBoard?.id != null) {
          setDialogState(null, 'replace');
          logAnalytics({ name: 'created board', details: { plexId: data?.createBoard?.id } });
        }
      })
      // Need this to avoid having an exception being thrown in dev
      .catch((_) => {
        return undefined;
      });
  };

  return (
    <BaseBoardDialog
      board={defaultBoard}
      mode={'create'}
      onSave={createBoard}
      saveLoading={loading}
      saveError={error}
    />
  );
}
